<template>
  <div class="disclaimer_section text-align-center border-bottom container-general">
    <span class="fw-bold">Quotazione richiesta il {{ infocar.giorno_creazione + ' ' + infocar.mese_creazione + ' ' + infocar.anno_creazione }}</span
    >. Valida solo nel mese solare in corso di elaborazione anche per
    <span class="fw-bold text-red">Comprare e Assicurare {{ infocar.mese_creazione + ' ' + infocar.anno_creazione }}</span>
  </div>
</template>

<script>
export default {
  name: 'DisclaimerSection',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/DisclaimerSection.vue